import { useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import useCollectionBannersList from '../cardCollections/hooks/useCollectionBannersList';
import { SLOT_SUBTYPES, SLOT_TYPES } from '../../constants';
import useFetchSelector from '../../hooks/useFetchSelector';
import { slotsPlainSelector } from './selectors';
import { fetchSlotsIfNeeded } from './slice';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { fetchPurchasesIfNeeded } from '../../actions/PurchaseActions';
import { NOOP } from '../../utils';
import { campaignsPlainSelector, fetchCampaignsIfNeeded } from '../campaigns';
export var useSlots = function (selector) {
    useFetchSelector(fetchSlotsIfNeeded, slotsPlainSelector);
    useFetchSelector(fetchCampaignsIfNeeded, campaignsPlainSelector);
    var slots = useSelector(selector);
    var collectionBanners = useCollectionBannersList();
    var dispatch = useAppDispatch();
    useEffect(function () {
        dispatch(fetchPurchasesIfNeeded()).catch(NOOP);
    }, [dispatch]);
    return useMemo(function () {
        return slots.filter(function (slot, i) {
            var _a;
            if (slot.type !== SLOT_TYPES.HEADLINE_SLOT ||
                (slot.subType === SLOT_SUBTYPES.COLLECTION &&
                    collectionBanners.length)) {
                return true;
            }
            // Do not show headlines that have no other slots as their content
            var isLastSlot = i === slots.length - 1;
            var isNextSlotAHeadline = ((_a = slots[i + 1]) === null || _a === void 0 ? void 0 : _a.type) === SLOT_TYPES.HEADLINE_SLOT;
            return !isLastSlot && !isNextSlotAHeadline;
        });
    }, [slots, collectionBanners]);
};
